import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b9e24ad2")

_pushScopeId("data-v-b9e24ad2")
const _hoisted_1 = { class: "shopping-list-append-ingredient-page" }
const _hoisted_2 = { class: "shopping-list-append-ingredient-page-top" }
const _hoisted_3 = {
  class: "shopping-list-append-ingredient-page-list",
  ref: "scroll"
}
const _hoisted_4 = { class: "shopping-list-append-ingredient-page-bottom" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "shopping-list-append-ingredient-page-bottom-top" }, null, -1)
const _hoisted_6 = { class: "shopping-list-append-ingredient-page-bottom-contents" }
const _hoisted_7 = { class: "shopping-list-append-ingredient-page-bottom-contents-button" }
const _hoisted_8 = { class: "shopping-list-append-ingredient-page-bottom-contents-button-button-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ShoppingListSearchInputView = _resolveComponent("ShoppingListSearchInputView")
  const _component_SelectCategory = _resolveComponent("SelectCategory")
  const _component_ShoppingListCategorySelectingIngredientList = _resolveComponent("ShoppingListCategorySelectingIngredientList")
  const _component_CommonDesignDialog = _resolveComponent("CommonDesignDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_ShoppingListSearchInputView, {
        isValidFocus: _ctx.isValidFocus,
        onSetSearchword: _ctx.setKeyword
      }, null, 8, ["isValidFocus", "onSetSearchword"]),
      _createVNode(_component_SelectCategory, {
        key: _ctx.updateCategoryKey,
        categoryNameList: _ctx.categoryNameList,
        selectIndex: _ctx.selectCategoryIndex,
        onOnSelect: _ctx.selectCategory
      }, null, 8, ["categoryNameList", "selectIndex", "onOnSelect"])
    ]),
    _createVNode("div", _hoisted_3, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.categoryIngredientList, (item) => {
        return (_openBlock(), _createBlock("div", {
          key: item.index
        }, [
          _createVNode(_component_ShoppingListCategorySelectingIngredientList, {
            index: item.index,
            totalCount: item.totalCount,
            ingredientList: item.ingredientList,
            onCheckIngredient: _ctx.checkAction,
            onRequestRead: _ctx.receiveRequestRead
          }, null, 8, ["index", "totalCount", "ingredientList", "onCheckIngredient", "onRequestRead"])
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ], 512),
    _createVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode("div", {
            class: "shopping-list-append-ingredient-page-bottom-contents-button-button",
            style: _ctx.styleAppendButton,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.appendButtonAction(...args)))
          }, [
            _createVNode("span", _hoisted_8, _toDisplayString(_ctx.appendButtonText), 1)
          ], 4)
        ])
      ])
    ]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: _ctx.isShowApiErrorDialog,
      dialogType: _ctx.typeApiError,
      title: _ctx.getApiErrorTitle,
      message: _ctx.getApiErrorMessage,
      positiveLabel: _ctx.retryButtonTitle,
      negativeLabel: _ctx.okButtonTitle,
      onPositiveClick: _ctx.retryApiErrorHandler,
      onNegativeClick: _ctx.okApiErrorHandler
    }, null, 8, ["isShowDialog", "dialogType", "title", "message", "positiveLabel", "negativeLabel", "onPositiveClick", "onNegativeClick"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: _ctx.isShowDesignDialog,
      dialogType: _ctx.designDialogType,
      title: _ctx.designDialogTitle,
      message: _ctx.designDialogMessage,
      negativeLabel: _ctx.designDialogNegativeButtonLabel,
      positiveLabel: _ctx.designDialogPositiveButtonLabel,
      onNegativeClick: _ctx.designDialogNegativeButtonAction,
      onPositiveClick: _ctx.designDialogPositiveButtonAction
    }, null, 8, ["isShowDialog", "dialogType", "title", "message", "negativeLabel", "positiveLabel", "onNegativeClick", "onPositiveClick"])
  ]))
})